import Feature, { FeatureLike } from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';

import { unByKey } from 'ol/Observable';
import { Coordinate } from 'ol/coordinate';
import Map, { FrameState } from 'ol/Map';
import BaseEvent from 'ol/events/Event';

export const addPulseToCoordinate = (
  map: Map,
  coordinate: Coordinate,
  times: number
): void => {
  const flashFeature = new Feature<Point>(new Point(coordinate));
  const flashLayerSource = new VectorSource<Feature<Point>>();
  let completedAnimations = 0;

  flashLayerSource.addFeature(flashFeature);

  const flashLayer = new VectorLayer<Feature<Point>>({
    source: flashLayerSource,
    style: function (feature: FeatureLike, resolution: number): Style {
      return new Style({
        image: new CircleStyle({
          radius: 10,
          fill: new Fill({
            color: 'rgba(255,0,0,0.10)',
          }),
          stroke: new Stroke({
            color: 'red',
            width: 8,
          }),
        }),
      });
    },
  });

  map.addLayer(flashLayer);

  let start: number = new Date().getTime();

  const animate = (event: BaseEvent | Event): void => {
    const frameState = (event as any).frameState as FrameState | undefined;
    if (!frameState) {
      return;
    }

    const duration = 6000;
    const elapsed: number = frameState.time - start;
    if (elapsed > duration) {
      completedAnimations += 1;
      if (completedAnimations >= times) {
        unByKey(listenerKey);
        map.removeLayer(flashLayer);
        return;
      }
      start = frameState.time;
    }

    const elapsedRatio: number = elapsed / duration;
    const radius: number = 5 + 25 * elapsedRatio;
    const opacity: number = 1 - elapsedRatio;

    const flashStyle: Style = new Style({
      image: new CircleStyle({
        radius: radius,
        stroke: new Stroke({
          color: `rgba(0, 0, 0, ${opacity})`,
          width: 0.2 + 2 * opacity,
        }),
      }),
    });

    flashLayer.setStyle(flashStyle);
    map.render();
  };

  const listenerKey = map.on('postrender' as any, animate);
};
